/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import EasySwipe from 'react-easy-swipe';
import { Modal, List } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import { CloseIcon } from '@shared/assets/icons';
import pubgTooltip from '@shared/assets/images/cyber/PubgTooltip.jpg';
import pubgTooltipMobile from '@shared/assets/images/cyber/PubgTooltipMobile.jpg';
interface ModalBannerProps {
  open: boolean;
  handleClose: () => void;
}
export const PubgTooltipMobile: FC<ModalBannerProps> = ({
  open,
  handleClose
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [swipeDirection, setSwipeDirection] = useState('');
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  useEffect(() => {
    setIsClosing(!open);
  }, [open]);
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      handleClose();
    }, 400);
  };
  return <StyledModal isClosing={isClosing} open={open} onClose={handleCloseModal} closeIcon={<CloseIcon />} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Heading>Как&nbsp;найти свой UID в&nbsp;PUBG Mobile?</Heading>
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <WrapperList>
            <List data={[{
            id: 1,
            text: 'Откройте приложение PUBG Mobile. Нажмите на\u00A0свой аватар в\u00A0левом верхнем углу главного экрана.'
          }, {
            id: 2,
            text: 'В\u00A0профиле вы увидите UID над аватаркой профиля'
          }]} size="md" sizemob="md" />
          </WrapperList>
          <Spacer space={20} spacetablet={20} spacemob={20} />
          <ImageWrapper>
            <Image src={pubgTooltip} width={536} height={140} alt="pubg" style={{
            borderRadius: '16px'
          }} />
          </ImageWrapper>
          <ImageWrapperMobile>
            <Image src={pubgTooltipMobile} width={335} height={140} alt="pubg" style={{
            borderRadius: '16px'
          }} />
          </ImageWrapperMobile>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
interface StyledModalProps {
  isClosing: boolean;
  open: boolean;
}
const _exp = /*#__PURE__*/() => Modal;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "s1h5034x",
  propsAsIs: true,
  vars: {
    "s1h5034x-0": [_exp2()],
    "s1h5034x-1": [_exp3()],
    "s1h5034x-2": [_exp7(), "px"],
    "s1h5034x-3": [_exp5()],
    "s1h5034x-4": [_exp6(), "px"],
    "s1h5034x-5": [_exp8()],
    "s1h5034x-6": [_exp9()],
    "s1h5034x-7": [_exp0()]
  }
}));
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperList = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperList",
  class: "wgepkbp",
  propsAsIs: false,
  vars: {
    "wgepkbp-0": [_exp1()]
  }
}));
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp14 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "h1arbkvj",
  propsAsIs: false,
  vars: {
    "h1arbkvj-0": [_exp10()],
    "h1arbkvj-1": [_exp11(), "px"],
    "h1arbkvj-2": [_exp12()],
    "h1arbkvj-3": [_exp13(), "px"],
    "h1arbkvj-4": [_exp14()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i1bfm9ka",
  propsAsIs: false
});
const ImageWrapperMobile = /*#__PURE__*/styled('div')({
  name: "ImageWrapperMobile",
  class: "i15kx5rl",
  propsAsIs: false
});

require("./PubgTooltipMobile.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PubgTooltipMobile.tsx");